import {
  ChangeDetectorRef,
  Component, ElementRef, HostListener, ViewChild,
} from '@angular/core';
import {NgForOf, NgIf} from '@angular/common';
import {BilletsService} from '../../../services/billets.service';

@Component({
  selector: 'emulator_gibdd-component',
  templateUrl: './emulator_gibdd.component.html',
  imports: [
    NgForOf,
    NgIf,

  ],
  styleUrl: './emulator_gibdd.component.less'
})
export class EmulatorGibddComponent {
  q_list: any = [];
  active_quantity: number = -1;
  @ViewChild('timerHTML', { static: true })
  timerHTML!: ElementRef<HTMLDivElement>;
  public totalSeconds = 20 * 60; // 20 минут
  public timer: any;
  public endTime = 0;
  public startTime = 0;       // время начала
  public spentSeconds = 0;    // сколько прошло
  public initialSeconds = 0;

  finish_question = false

  close_finish_result = false;

  status_exzamen = true


  constructor(private cdr: ChangeDetectorRef, public BilletsService:BilletsService,) {}
  ngOnInit() {
    let bilet_index = Math.floor(
      Math.random() * this.BilletsService.billets_list.length
    );

    let billet = this.BilletsService.billets_list[bilet_index]
    this.q_list = []
    for(let i =0; i < this.BilletsService.billets_question.length; i++){
      if(billet.includes(this.BilletsService.billets_question[i].id)){
        this.q_list.push(  structuredClone(this.BilletsService.billets_question[i]));
      }
    }

    this.startTimer()

  }


  startTimer(): void {
    this.startTime = Date.now();
    this.endTime = Date.now() + this.totalSeconds * 1000;
    this.initialSeconds = this.totalSeconds; // Запоминаем стартовое время
    this.timer = setInterval(() => {

      this.totalSeconds = Math.max(
        0,
        Math.floor((this.endTime - Date.now()) / 1000)
      );


      this.spentSeconds =   this.initialSeconds - this.totalSeconds;
      let text_timer:string =  `${Math.floor(this.totalSeconds / 60).toString().padStart(2, '0')}:` +
        `${(this.totalSeconds % 60).toString().padStart(2, '0')}`;

      this.timerHTML.nativeElement.textContent = text_timer.toString()


      if (this.totalSeconds === 0) {
        this.SetFinishQuestion()
        this.cdr.detectChanges();
      }

    }, 1000);

  }



  ngOnDestroy(): void {
    clearInterval(this.timer);
    this.q_list = []
  }


  open_quation(index:number){
    this.active_quantity = index;
  }

  prew_quation(index:number){
    if(index >= 0){
      this.active_quantity = index;
    }

  }
  next_quation(index:number){
    if(index <= this.q_list.length -1){
      this.active_quantity = index;
    }
  }

  select_answer(index:number){
    for (let i = 0; i < this.q_list[this.active_quantity].answers.length; i++) {
      if(i == index){
        this.q_list[this.active_quantity].answers[i].emulator_gibdd_select = true
      }else{
        this.q_list[this.active_quantity].answers[i].emulator_gibdd_select = false
      }
    }

    this.q_list[this.active_quantity].emulator_gibdd_select = true

  }


  check_q(){
    if(this.q_list[this.active_quantity].emulator_gibdd_select && !this.q_list[this.active_quantity].emulator_gibdd_cheked &&  this.finish_question == false ){
      this.q_list[this.active_quantity].emulator_gibdd_cheked = true;
      for (let i = 0; i < this.q_list[this.active_quantity].answers.length; i++) {
        if(this.q_list[this.active_quantity].answers[i].emulator_gibdd_select == true){
          this.q_list[this.active_quantity].answers[i].emulator_gibdd_cheked = true;
        }else{
          this.q_list[this.active_quantity].answers[i].emulator_gibdd_cheked = false;
        }
      }

      let finish = true
      let count_error = 0
      for (let i = 0; i < this.q_list.length; i++) {
        if(!this.q_list[i].emulator_gibdd_cheked){
          finish = false
        }

        let q_status = 0
        for (let j = 0; j < this.q_list[i].answers.length; j++) {
          if( this.q_list[i].answers[j].emulator_gibdd_cheked == true){
            if(this.q_list[i].answers[j].correct == true){
              q_status = 1
            }else{
              q_status = 2
            }
            break;
          }
        }

        if(q_status == 2){
          count_error++
        }
      }

      if(count_error > 4){
        finish = true
      }


      if(finish == true){
        this.SetFinishQuestion()
      }


      this.open_quation(-1)
    }

  }

  SetFinishQuestion(){
    this.finish_question = true
    clearInterval(this.timer);
    let count_error = 0
    for (let i = 0; i < this.q_list.length; i++) {
      let q_status = 0
      for (let j = 0; j < this.q_list[i].answers.length; j++) {
        if( this.q_list[i].answers[j].emulator_gibdd_cheked == true){
          if(this.q_list[i].answers[j].correct == true){
            q_status = 1
          }else{
            q_status = 2
          }
          break;
        }
      }
      this.q_list[i].status = q_status

      if(this.q_list[i].status  !== 1){
        count_error ++
      }

    }

    if(count_error > 4){
      this.status_exzamen = false
    }

  }


  conutErorr(){
    let count_error = 0
    for (let i = 0; i < this.q_list.length; i++) {
      if(  this.q_list[i].status != 1){
        count_error++
      }
    }

    return count_error
  }


  getTimeUs(){

    const minutes = Math.floor(this.spentSeconds / 60);
    const seconds = this.spentSeconds % 60;

    console.log(`${minutes}:${seconds}`);

   return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`


  }

}
